import { errorHandler, addSentryBreadcrumb } from '@/utils/errorHandler'

export default {
    data() {
        return {
            QRLoading: false
        }
    },
    computed: {
        hasLoader() {
            return this.$store.state.common.mainLoader || this.$store.state.common.circularLoader
        }
    },
    methods: {
        QRtoJSON(event) {
            if (this.hasLoader) return

            // QR paste tester
            if (process.env.VUE_APP_ENV === 'local') {
                if (event.ctrlKey && event.key === 'v') {
                    navigator.clipboard.readText().then(clipText => {
                        // clipText = clipText.replace(/[\u201C\u201D]/g, '"') - dodatkowa linia dla użytkowników MacOS
                        this.handleQrJSON({
                            data: JSON.parse(clipText),
                            origin: 'scanner'
                        })
                    })

                    return
                }
            }

            const ignoredKeys = ['Shift', 'Enter', 'Alt', 'Control']

            if (ignoredKeys.includes(event.key)) return

            if (event.key == '{') {
                countOpenCurlyBrace++
                this.QRLoading = true

                // [FIX]
                // blur() na aktywny element, aby zapobiec wrzuceniu JSONa w pole formularza
                const element = document.querySelector(':focus')

                if (element) element.blur()
            }

            if (event.key == '}') {
                countCloseCurlyBrace++
            }

            qrString += event.key

            if (!qrString.startsWith('{')) {
                qrString = ''
                countOpenCurlyBrace = 0
                countCloseCurlyBrace = 0

                return
            }

            if (countOpenCurlyBrace !== 0 && (countOpenCurlyBrace === countCloseCurlyBrace)) {
                addSentryBreadcrumb('ui.action', 'Skan QR', { data: qrString })

                try {
                    this.handleQrJSON({
                        data: JSON.parse(qrString),
                        origin: 'scanner'
                    })
                }
                catch (error) {
                    this.$store.dispatch('showNotification', {
                        type: 'error',
                        message: this.$i18n.t('reports.messages.incorrectQrCode')
                    })
                    errorHandler(error)
                }
                finally {
                    qrString = ''
                    countOpenCurlyBrace = 0
                    countCloseCurlyBrace = 0
                    this.QRLoading = false
                }
            }
        },
        // [Fix]
        // Domyślnie dostarczony skaner QR zatwierdza zeskanowany kod enterem.
        // Kiedy aktywna jest pozycja listy w menu głównym oraz zeskanowano kod QR,
        // wywołują się jednocześnie dwie rzeczy: event obsługujący dekodowanie JSONa z QR,
        // oraz zatwierdzenie pozycji w menu. To powoduje, że aplikacja wraca do listy
        // zamiast przekierować do widoku pojedynczego raportu. Skaner ma możliwość
        // wyłączenia zatwierdzenia enterem, jednak potrzebny jest fallback na domyślne
        // działanie skanera.
        // setTimeout rozwiązuje problem.
        scannerEnterFallback(event) {
            setTimeout(() => {
                event()
            }, 10)
        }
    }
}

let qrString = '',
    countOpenCurlyBrace = 0,
    countCloseCurlyBrace = 0